import { useNavigate } from "react-router-dom";
import { Row, Col } from 'react-bootstrap';
import BackIcon from '../../../../styles/images/back-without-bg.png';


const Rules = () => {

    const navigate = useNavigate();

    const handleBackBtn = () => {
        navigate(-1);
    };


    return (

        <div id="rules-page">
            <Row className="py-3 white-bg sticky top-0 z-index-2">
                <Col xs={1} className="d-flex align-items-center"><img src={BackIcon} alt="back" onClick={handleBackBtn} role="button" /></Col>
                <Col xs={10} className="text-center">
                    <div className="header_h3">
                        قوانین و مقررات وبسایت سیتگ
                    </div>
                </Col>
                <Col xs={1}></Col>
            </Row>

            <Row className="mt-5">
                <Col xs={12} className="text-justify">
                    <p>
                        تعاریف و اصطلاحات:
                    </p>
                    <ul>
                        <li>
                            کسب و کار: به تمام مجموعه و واحدهاي ارائه دهنده خدمات حضوري و غیر حضوري ثبت شده در سیتگ گفته میشود.
                        </li>
                        <li>
                            خریدار (مشتري): فرد یا افرادي که از سایت و یا مجموعه‌هاي معرفی شده در سایت سیتگ اقدام به خرید کرده‌اند.
                        </li>
                        <li>
                            حساب کاربري: حسابی که کاربران براي استفاده از خدمات سیتگ در آن ایجاد کرده‌اند.
                        </li>
                    </ul>



                    <p>
                        قوانین و مقررات ثبت نام و استفاده از سیتگ:
                    </p>
                    <ul>
                        <li>
                            کاربر با ثبت نام در سیتگ می‌پذیرد که قوانین و مقررات سیتگ را به صورت کامل مطالعه کرده، به مفاد آن آگاه و تمام موارد آن را پذیرفته است. در صورتیکه در آینده در این قوانین و مقررات تغییراتی ایجاد شود، در همین صفحه به روزرسانی و منتشر میشود و کاربر توافق می‌کند که استفاده مستمر از سایت به معنی پذیرش هرگونه تغییر است.
                        </li>
                        <li>
                            مسئولیت حساب کاربري به عهده مشتري می‌باشد و همواره باید در حفظ و نگه داري شماره موبایل حساب کاربري و کد احراز هویت (ورود) کوشا باشد و هر گونه سواستفاده از پروفایل شخصی به عهده صاحب حساب کاربری می‌باشد.
                        </li>
                        <li>
                            شماره موبایل ثبت شده در پنل سیتگ شما هویت شماست و هر تماسی با این شماره از نظر سیتگ، صاحب حساب کاربري میباشد.
                        </li>
                        <li>
                            مسئولیت تمام فعالیت‌هایی که از طریق حساب کاربري اشخاص در سیتگ انجام می‌شود به عهده خود شخص است.
                        </li>
                        <li>
                            در سیتگ براي هر کاربر کیف پول اعتباري در نظر گرفته می‌شود که میتواند آن را شارژ کرده و از طریق موجودي کیف پول هزینه‌هاي مربوط به خریدها و استفاده از سایر خدمات سیتگ را پرداخت کند. در صورت نیاز به عودت وجه، مبلغ به کیف پول خریدار بازگردانده می‌شود.
                        </li>
                    </ul>




                    <p>
                        قوانین و مقررات عمومی:
                    </p>
                    <ul>
                        <li>
                            سیتگ تنها یک بستر ارتباطی میان کسب و کار و خریدار است و به عنوان کسب و کار محسوب نم‌یشود. در سیتگ کسب و کار، خود را معرفی می‌کند و خریدار نیز با آگاهی نسبت به فعالیت پلتفرم سیتگ اقدام به خرید می‌کند. سیتگ در جهت بهبود ارائه خدمات نهایت تلاش خود را می‌کند.
                        </li>
                        <li>
                            خریدار می‌پذیرد خرید در سیتگ به معناي تأیید مقررات آن کسب و کار از سوي ایشان است و می‌بایست به ضوابط آن پایبند باشد.
                        </li>
                        <li>
                            قوانین استرداد در مجموعه‌هاي مختلف متفاوت میباشد و شرایط استرداد وجه طبق قوانین کسب و کارها انجام می‌شود.
                        </li>
                        <li>
                            جهت واریز مبلغ از کیف پول سیتگ به حساب بانکی شخصی باید اطلاعات شخصی و حساب خود را به درستی وارد کرده باشد لذا درغیر اینصورت مسئولیت مشکل بوجود آمده بر عهده شخص صاحب حساب میباشد.
                        </li>
                        <li>
                            حداقل مبلغ قابل برداشت 500000 ریال میباشد که بعد از ثبت درخواست در بازه 3 الی 5 روزکاري وجه به حساب بانکی ثبت شده توسط خریدار واریز خواهد شد.
                        </li>
                        <li>
                            لغو یا مرجوع کردن خرید منجر به کسر مبلغ بازگست وجه براي کالاهاي خریداري شده میشود.
                        </li>
                        <li>
                            خریدار براي استفاده از بازگشت وجه خرید حضوری و اینترنتی باید ابتدا وارد حساب کاربري خود در سیتگ شود.
                        </li>
                        <li>
                            خریدار باید براي دریافت بازگشت وجه حضوري بای وارد حساب کاربری خود در سیتگ شود و از یکی از روش های ارائه کد خرید یا انتقال وجهاز کیف پول پرداخت خود را انجام دهد. در غیر این صورت مبلغی جهت بازگشت وجه در حساب خریدار لحاظ نخواهد شد.
                        </li>
                    </ul>
                </Col>
            </Row>

        </div>

    );
}

export default Rules;